import {Deserializable} from './deserializable';
import {BaseModel} from './baseModel';


export class ControlDevice extends BaseModel implements Deserializable {

  id: number;  // id assegnato dal server
  serial: string;
  address: string;  // parametro per Android
  deviceType: string;
  latitude: number;
  longitude: number;
  name: string;

  deserialize(input: any) {

    super.deserialize(input);
    Object.assign(this, input);

    return this;
  }
}
